import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

export interface GetClassCalendarParams {
  startDate?: string;
  endDate?: string;
}

export interface ClassCalendarResponse {
  data: Array<{
    title: string;
    start: string;
    end: string;
    resourceId: string;
    color: string;
    day?: string;
    capacity?: number | null;
    spotsRemaining?: number | null;
    locationId?: string | null;
    locationName?: string;
    sessionId?: string | null;
    sessionName?: string;
    minAge?: number | null;
    maxAge?: number | null;
  }>;
  total: number;
}

export const getClassCalendarAPI = async (params: GetClassCalendarParams) => {
  const response = await baseAPI.get<ClassCalendarResponse>(
    `/enrollments/calendar/all`,
    {
      params,
    },
  );
  return response.data;
};

export const getClassCalendarQueryOptions = (params: GetClassCalendarParams) =>
  queryOptions({
    queryKey: [...QUERY_KEYS.CLASSES(), params],
    queryFn: () => getClassCalendarAPI(params),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
  });

export const useGetClassCalendar = (params: GetClassCalendarParams) => {
  return useQuery(getClassCalendarQueryOptions(params));
};
